<div class="px-4 py-5">
  <slot />
</div>
